import { useRouter } from "next/router";
import type { FunctionComponent } from "react";
import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";

import { getUrlPathWithoutQuery } from "~/lib/utils";
import type { topicHeaderRelatedLinksTopic$key } from "~/queries/__generated__/topicHeaderRelatedLinksTopic.graphql";

import { Container, StyledBaseLink } from "./styles";

type Props = {
  className?: string;
  reference: topicHeaderRelatedLinksTopic$key;
};

export const TopicHeaderRelatedLinks: FunctionComponent<Props> = ({
  className,
  reference: reference_,
}) => {
  const topic = useFragment(
    graphql`
      fragment topicHeaderRelatedLinksTopic on Topic {
        relatedLink {
          title
          url
        }
      }
    `,
    reference_,
  );

  const scrollSelectedElementIntoView = useCallback((element: HTMLElement | null) => {
    element?.scrollIntoView({ block: "nearest", inline: "start" });
  }, []);

  const { asPath } = useRouter();
  const renderRelatedLinks = () =>
    topic?.relatedLink?.map((link, index) => {
      const isSelected = link?.url === getUrlPathWithoutQuery(asPath);
      return link?.url ? (
        <StyledBaseLink
          $isSelected={isSelected}
          key={index}
          pathname={link?.url}
          ref={isSelected ? scrollSelectedElementIntoView : null}
        >
          {link?.title}
        </StyledBaseLink>
      ) : null;
    });

  return (topic?.relatedLink ?? []).length > 0 ? (
    <Container className={className}>{renderRelatedLinks()}</Container>
  ) : null;
};

TopicHeaderRelatedLinks.displayName = "TopicHeaderRelatedLinks";
